<p class="mb-2 text-xs font-medium tracking-wide text-gray-500 uppercase">{{ legend() }}</p>

<mib-button-toggles
  [segments]="segments()"
  [value]="active()"
  [aria-label]="legend()"
  [disabled]="pending()"
  (valueChange)="pick($event)"></mib-button-toggles>
